import { alpha, Button, ButtonProps, Typography } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'
import { SxProps, Theme } from '@mui/system'
import React, { forwardRef } from 'react'
import useAppUtilities from '../../hooks/useAppUtilities'

export interface CustomButtonProps extends Omit<ButtonProps, 'color'> {
  icon?: React.ReactNode
  endComponent?: React.ReactNode
  title?: string
  textColor?: string
  backgroundColor?: string
  action?: () => void
  sx?: SxProps<Theme>
  textVariant?: Variant
  hoverColor?: string
  disabledTextColor?: string
}

const CustomButton = forwardRef<HTMLInputElement, CustomButtonProps>(
({
  icon,
  title,
  textColor,
  backgroundColor,
  action,
  sx,
  textVariant = 'body2',
  endComponent,
  hoverColor,
  disabledTextColor,
  ...props
},ref) => {
  const { theme } = useAppUtilities()

  return (
    <Button
      onClick={action}
      sx={{
        backgroundColor: backgroundColor ?? theme.palette.primary.main,
        color: textColor ?? theme.palette.primary.contrastText,
        border: `1px solid ${
          textColor ?? backgroundColor ?? theme.palette.primary.main
        } `,
        borderRadius: theme.shape.borderRadius,
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        '&.MuiButton-root': {
          '&:hover': {
            backgroundColor: alpha(
              backgroundColor ?? theme.palette.primary.main,
              0.8,
            ),
            color: alpha(hoverColor ?? theme.palette.background.paper, 0.8),
          },
          '&.Mui-disabled': {
            color: disabledTextColor ?? textColor,
            cursor: 'not-allowed',
            pointerEvents:'unset',
            backgroundColor: alpha(
              backgroundColor ?? theme.palette.background.paper,
              0.8,
            ),
          },
        },
        paddingX: '16px',
        ...sx,
      }}
      {...props}
    >
      {icon && icon}
      {title && <Typography variant={textVariant}>{title}</Typography>}
      {endComponent && endComponent}
    </Button>
  )
})

CustomButton.displayName='CustomButton'

export default CustomButton
